import { render, staticRenderFns } from "./projectsdetail.vue?vue&type=template&id=1a2d27ca&scoped=true&"
var script = {}
import style0 from "./projectsdetail.vue?vue&type=style&index=0&id=1a2d27ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d27ca",
  null
  
)

export default component.exports